module.exports = __webpack_public_path__ + "static/media/orionBanner.076e2354.jpg";